import { t } from 'i18next';
import { notification } from 'antd';

import { handleApiError } from '@/api';
// import { addNotification } from '@/redux/slices/notificationSlice';

export const SCOPES = {
  SETTINGS_MINOR_DELAY: 'settings.minor_delay',
  SETTINGS_PROJECTED_DELAY: 'settings.projected_delay',
  SETTINGS_ALARM: 'settings.alarm',
  SETTINGS_HEALTH_CHECK_CONFIG: 'settings.health_check',
  SETTINGS_BUS_IS_LATE: 'settings.bus_is_late',
  SETTINGS_WASH_RULES: 'settings.wash_rules',
  SETTINGS_COMMENT_CONFIGURATOR: 'settings.comment_configurator',
} as const;

export const MESSAGES = {
  LOAD: 'load',
  ADD: 'add',
  UPDATE: 'update',
  DELETE: 'delete',
} as const;

export const createNotificationHandler =
  (
    setErrorAction: (error: string) => any,
    scope: string,
    messageKey: string,
    showSuccess: boolean = true
  ) =>
  async (_args: any, { dispatch, queryFulfilled }: any) => {
    try {
      await queryFulfilled;
      if (showSuccess) {
        notification.success({
          message: t(`common.notifications.title.success`),
          description: t(`${scope}.${messageKey}_success`),
        });

        // Add notification to Notification Drawer
        // dispatch(
        //   addNotification({
        //     type: 'success',
        //     message: t(`settings.${scope}.${messageKey}_success`),
        //   })
        // );
      }
    } catch (error: any) {
      const errorMessage = handleApiError(t, error);
      dispatch(setErrorAction(errorMessage.data.detail));
      const status = error?.status ?? error?.error?.status;

      // HTTP 409 Conflict
      if (status === 409) {
        // const detail =
        //   error?.data?.detail ||
        //   error?.error?.data?.detail ||
        //   errorMessage.data.detail;
        notification.error({
          message: t(`common.notifications.title.conflict`),
          description: t(`${scope}.conflict`),
          // + (detail ? ` (${detail})` : ''),
        });
        return;
      }

      // Generic error
      notification.error({
        message: t(`common.notifications.title.error`),
        description: t(`${scope}.${messageKey}_error`),
      });

      // Add notification to Notification Drawer
      // dispatch(
      //   addNotification({
      //     type: 'error',
      //     message: t(`settings.${scope}.${messageKey}_failed`),
      //     description: errorMessage.data.detail,
      //   })
      // );
    }
  };
